import { useBitrix } from '@context/useBitrixUser/useBitrix';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CalculationsMenuStatus } from '../../../CalculationsMenu/components/CalculationsMenuStatus';
import { HistoryMenuItem } from '../HistoryMenuItem';
import { useHistoryMenuSections } from '../../useHistoryMenuSections';

/**
 * Пропсы компонента
 */
type HistoryMenuListProps = {
  sectionId: string;
  isOpen: boolean;
};

/**
 * Последние расчеты раздела в меню истории
 */
export const HistoryMenuList = ({ sectionId, isOpen }: HistoryMenuListProps) => {
  const { t } = useTranslation(['DeliveryForm']);
  const { useBitrixUser } = useBitrix();
  const [{ history }] = useBitrixUser().useState(['history']);
  const { items, isLoading } = useHistoryMenuSections(history, sectionId, isOpen);

  return (
    <>
      {items.map((historyItem) => (
        <HistoryMenuItem key={`history-menu-item--${historyItem.id}`} historyItem={historyItem} />
      ))}
      {(isLoading || items.length === 0) && (
        <CalculationsMenuStatus isLoading={isLoading} emptyText={t('DeliveryForm:HistoryEmpty')} />
      )}
    </>
  );
};
